import { useLocation } from '@marketplace-web/shared/browser'

type UseElectronicsLpVersionReturnType = 'buy' | 'sell'

const useElectronicsLpVersion = (): UseElectronicsLpVersionReturnType => {
  const { relativeUrl } = useLocation()

  return relativeUrl.includes('buy') ? 'buy' : 'sell'
}

export default useElectronicsLpVersion
